var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoadingLogo = function SvgLoadingLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 290,
    height: 65,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loading-logo_svg__b",
    x1: "-100%",
    x2: "800%",
    y1: "100%",
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BB3A90"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    dur: "4s",
    repeatCount: "indefinite",
    values: "0;1"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgba(255, 255, 255, 0.3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    dur: "2s",
    repeatCount: "indefinite",
    values: "0;1"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "rgba(255, 255, 255, 0.3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    dur: "2s",
    repeatCount: "indefinite",
    values: "0.1;1"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BB3A90"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    dur: "4s",
    repeatCount: "indefinite",
    values: "0.1;1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#loading-logo_svg__b)",
    clipPath: "url(#loading-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.982 22.997a6.72 6.72 0 0 1 2.99 2.532 7.79 7.79 0 0 1 0 7.81 6.69 6.69 0 0 1-3.007 2.545 11.162 11.162 0 0 1-4.607.882H3.78v5.943H0V22.114h8.375a11.16 11.16 0 0 1 4.607.883Zm-1.032 9.472c.404-.391.725-.861.945-1.382a4.236 4.236 0 0 0-.945-4.676c-.868-.699-2.122-1.048-3.76-1.048H3.78v8.18h4.41c1.638 0 2.896-.357 3.752-1.061l.008-.013Zm35.378-10.356v20.595h-3.78v-8.826H33.024v8.826h-3.776V22.113h3.776v8.503h10.524v-8.503h3.78Zm27.093 15.83H64.25l-2.007 4.765h-3.894l9.156-20.595h3.723l9.185 20.595h-3.956l-2.047-4.766h.012Zm-1.249-3-3.837-9.005-3.813 9.004h7.65Zm31.574 7.765-4.156-6.033a7.461 7.461 0 0 1-.787.029H95.21v6.004h-3.78V22.114h8.374c1.586-.039 3.161.262 4.624.882a6.755 6.755 0 0 1 3.01 2.532 7.163 7.163 0 0 1 1.044 3.912 7.028 7.028 0 0 1-1.118 3.998 6.681 6.681 0 0 1-3.211 2.487l4.681 6.766-4.087.017Zm-1.368-16.297c-.851-.709-2.105-1.061-3.75-1.061h-4.42v8.209h4.42c1.637 0 2.899-.36 3.75-1.074.431-.374.77-.843.991-1.371.222-.529.32-1.101.287-1.674a3.717 3.717 0 0 0-1.278-3.03Zm36.427 16.297-.029-13.65-6.687 11.296h-1.688l-6.683-11.122v13.476h-3.608V22.113h3.113l8.079 13.65 7.937-13.65h3.112l.029 20.595h-3.575Zm17.687-29.698v38.657h2.994V13.01h-2.994Zm19.235 27.444c-1.573-1.597-2.358-3.886-2.355-6.866V21.985h3.768v11.47c0 4.042 1.725 6.063 5.176 6.063s5.167-2.021 5.148-6.063V21.97h3.718V33.57c0 2.978-.779 5.267-2.338 6.866-1.559 1.6-3.743 2.4-6.553 2.4-2.809 0-4.993-.8-6.552-2.4l-.012.017Zm47.266-18.34v20.594h-3.108l-11.221-13.944v13.944h-3.751V22.113h3.108l11.225 13.944V22.113h3.747Zm13.9 0h3.775v20.594h-3.775V22.113ZM269.134.843v50.823l6.798-6.415V.844a16.966 16.966 0 0 0-6.798 0Zm13.592 3.095v27.507l.11 7.276 6.692-6.315V17.693a17.33 17.33 0 0 0-1.792-7.69 17.115 17.115 0 0 0-5.006-6.064h-.004Zm-27.188 13.753v46.825l6.798-6.419V3.94a17.115 17.115 0 0 0-5.006 6.064 17.33 17.33 0 0 0-1.792 7.69Z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loading-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h289.524v64H0z"
  })))));
};
export default SvgLoadingLogo;